










import {
  containsDryingInfo,
  containsLeakDetectionInfo,
  getProjectTypeCode,
  getProjectTypeIdOfProject,
  ProjectDetails,
  ProjectTypeConfig,
} from "@/data/models/ProjectDetails";
import ProjectOverview from "@/data/models/ProjectOverview";
import { getLastestProjectStateForProjectTypeDisplay, getProjectTypeDisplayColor } from "@/data/models/ProjectState";
import { Component, Vue, Prop } from "vue-property-decorator";
import { themedFill, themedFillTextColor } from "@/utils/Theme";

@Component
export default class ProjectTypeDisplayComponent extends Vue {
  @Prop()
  project!: ProjectDetails | ProjectOverview;
  @Prop() projectTypes!: ProjectTypeConfig[];

  get showLeakDetectionType() {
    return containsLeakDetectionInfo(this.project);
  }

  get showDryingType() {
    return containsDryingInfo(this.project);
  }

  get projectTypeCode() {
    const projectTypeId_ = (this.project as ProjectOverview).projectTypeId ?? (this.project as ProjectDetails).clientData?.projectTypeId;
    const projectTypeId = projectTypeId_ ?? getProjectTypeIdOfProject(this.project);
    return getProjectTypeCode(this, projectTypeId, this.projectTypes);
  }

  get projectTypeColor() {
    const today = new Date();
    const latestProjectState = getLastestProjectStateForProjectTypeDisplay(this.project as ProjectOverview, today);
    return getProjectTypeDisplayColor(latestProjectState);
  }

  /**
   * The badge fill and code colour for the active theme: in dark mode the palette shade of the
   * project-type colour with dark text. A project with no state has no fill (`""`), and then keeps
   * the theme's own text colour, which stays readable on the row behind it.
   */
  get badgeStyle() {
    const color = this.projectTypeColor;

    return {
      "background-color": themedFill(color),
      color: themedFillTextColor(color, ""),
    };
  }
}
